/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Close_SuccessInputs */

const en_settings_tickets_close_success = /** @type {(inputs: Settings_Tickets_Close_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ticket closed`)
};

const zh_settings_tickets_close_success = /** @type {(inputs: Settings_Tickets_Close_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工单已关闭`)
};

/**
* | output |
* | --- |
* | "Ticket closed" |
*
* @param {Settings_Tickets_Close_SuccessInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_close_success = /** @type {((inputs?: Settings_Tickets_Close_SuccessInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Close_SuccessInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_close_success(inputs)
	return zh_settings_tickets_close_success(inputs)
});
export { settings_tickets_close_success as "settings.tickets.close_success" }